import { Button } from "@themes/pollinator/ui/Button";
import { Image } from "@themes/pollinator/ui/Image";

export type Props = {
  /** Button label text */
  label: string;
  /** Click handler */
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** Loading state */
  isLoading?: boolean;
  /** Additional CSS classes */
  className?: string;
  /** Test ID for testing */
  "data-testid"?: string;
};

// Architecture Note: This GoogleButton does NOT wrap GoogleButtonBase.
// Reason: GoogleButtonBase renders a raw <button> element, but this styled
// component uses the Button component from @themes/pollinator/ui/Button which already
// wraps ButtonBase. Using GoogleButtonBase would result in nested buttons.
// The logic is simple enough (loading state toggle) that it doesn't need
// the base component abstraction.

/**
 * Styled Google OAuth button component.
 * Shows the Google logo and handles loading state.
 */
export function GoogleButton({
  label,
  onClick,
  isLoading = false,
  className,
  "data-testid": testId = "google-button",
}: Props) {
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      disabled={isLoading}
      data-testid={testId}
      className={className}
    >
      <span className="inline-flex items-center justify-center gap-2">
        {isLoading ? (
          <>
            <div className="w-4 h-4 border-2 border-brand-400 border-t-transparent rounded-full animate-spin animate-spin-slow" />
            Loading...
          </>
        ) : (
          <>
            <Image
              src="https://mnma.imgix.net/projects/pollinator/google-logo.png"
              alt="Google"
              className="w-4"
            />{" "}
            {label}
          </>
        )}
      </span>
    </Button>
  );
}

export default GoogleButton;

